<ng-template #tabLinkTemplate>
  <ng-content select="[ui-tab-link]"></ng-content>
</ng-template>
<ng-template #contentTemplate><ng-content></ng-content></ng-template>
